import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import ClassicQuizBasicModel from "./ClassicQuizBasicModel";

export default class ClassicQuizzesModel {
  public meta: MetaModel = new MetaModel();
  public data: ClassicQuizBasicModel[] = [];
}
